/**
 * ATT-2872 admin half — tenant DISCOVERY allowlist (boot-time identity hydration).
 *
 * Disjoint from `lib/tenantSettings/registry.ts` (the ATT-2871 overlay) by
 * design (see design.md §D3 + pre-mortem risk #9):
 *   - tenantSettings (ATT-2871) overlays 2 keys post-boot for hosts with
 *     `useBackendSettings` enabled: feature_flags + logo_url.
 *   - tenantDiscovery (ATT-2872 / ATT-3383) hydrates 4 keys at boot for every
 *     host (registry-only): display_name + hide_languages + feature_flags +
 *     logo_url.
 *
 * Both modules consume the same shared core fetcher
 * (`lib/tenantSettings/fetch.ts#fetchTenantSettings`) but apply different
 * per-key Zod allowlists on top. Drift between the two over time is the risk
 * monitored at ATT-2873 §12.2 entry.
 */

import { z } from "zod";

export const DiscoveryTenantSettingKey = {
  display_name: z.string(),
  hide_languages: z.array(z.string()),
  feature_flags: z.array(z.string()),
  logo_url: z.string().url().nullable(),
} as const;

export type DiscoveryTenantSettingKeyName = keyof typeof DiscoveryTenantSettingKey;

export const DISCOVERY_TENANT_SETTING_KEYS: DiscoveryTenantSettingKeyName[] = Object.keys(
  DiscoveryTenantSettingKey,
) as DiscoveryTenantSettingKeyName[];

export function isDiscoveryAllowlistedKey(key: string): key is DiscoveryTenantSettingKeyName {
  return Object.prototype.hasOwnProperty.call(DiscoveryTenantSettingKey, key);
}
